export default "__VITE_ASSET__CSGz_Y4e__"